import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Linkedin = createReactComponent("Linkedin", ["svg", defaultAttributes, [["path", {
  d: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z",
  key: "dxpxhk"
}], ["rect", {
  x: "2",
  y: "9",
  width: "4",
  height: "12",
  key: "zi0lh6"
}], ["circle", {
  cx: "4",
  cy: "4",
  r: "2",
  key: "nx0fkr"
}]]]);
export default Linkedin;